import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BatchDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-batch',
  templateUrl: './batch.component.html',
  styleUrls: ['./batch.component.scss']
})
export class BatchComponent implements OnChanges {
  batchForm: FormGroup;
  batchFormArray: FormGroup;
  control = new FormControl();
  @Input() batchs: BatchDto[];
  @Input() routeAnimationsElements: any;
  @Output() batch = new EventEmitter<BatchDto[]>()
  @Output() deleteBatchEvent = new EventEmitter<any>()

  selectedBatch: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}
     ngOnChanges() {
      this.createBatchForm();
    }

    createBatchForm() {
      this.batchForm = this.fb.group({
        BatchName: ['', Validators.required],
        id: null
        });
        this.batchFormArray = this.fb.group({ Batchs: this.fb.array([])
          });
        this.setBatch();
    }

  // method to display batchs
  setBatch() {
    const control  = this.batchFormArray.controls.Batchs as FormArray;
    this.batchs.forEach( e => {
      control.push(
        this.fb.group({
          BatchName: e.BatchName,
          id: e.id
        })
      );
    });
  }


  // method to add Batch
  addBatch(value: BatchDto) {
    const control  = this.batchFormArray.controls.Batchs as FormArray;
    control.insert(0,
          this.fb.group({
            BatchName: value.BatchName,
            id: null
          })
       );
  }

  selectBatch(value) {}

  // method to delete batch from arrary list
  deleteBatch(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.batchFormArray.controls.Batchs as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.batchs.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.batchs[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: BatchDto) {
    if(this.batchForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.batchFormArray.get('Batchs')['controls'][this.selectedIndex].patchValue({BatchName: formValue.BatchName});
    } else {
      this.addBatch(formValue);
    }
    this.selectedIndex = null;
    this.batchForm.reset()
  }

  onEdit(index, value: BatchDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.batchForm.patchValue({BatchName: value.BatchName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.batchForm.reset();
  }

  onSubmit(formValue: BatchDto[]) {
  this.batch.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteBatchEvent.emit(this.filteredDelete);
  }
  }

}
